/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Header_Extra_Links1Inputs */

const vi_sitesettings_header_extra_links1 = /** @type {(inputs: Sitesettings_Header_Extra_Links1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mục menu thêm`)
};

/**

* @param {Sitesettings_Header_Extra_Links1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_header_extra_links1 = /** @type {((inputs?: Sitesettings_Header_Extra_Links1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Header_Extra_Links1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_header_extra_links1(inputs)
});
export { sitesettings_header_extra_links1 as "siteSettings_header_extra_links" }